import React from 'react';
import { offer } from '../../data/offer';
import { BrandMark } from '../ui/BrandMark';
import { PendingNote } from '../ui/PendingNote';
export function SiteFooter() {
  return <footer className="bg-petrol pb-28 pt-12 text-white" data-id="element-170" data-mp="1fgx5yvy8sh6b">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-171" data-mp="1fhgp2fzmpblx">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-172" data-mp="1kg0bsim1qrfc">
          <div data-id="element-173" data-mp="nq12un1zhqw8">
            <BrandMark data-id="element-174" data-mp="nqiwdbx9hr0g" />
            <p className="mt-3 text-sm text-white/70" data-id="element-175" data-mp="nrc8ksezp8pz">Volume 01 · Fall Sessions: Starter Kit</p>
          </div>
          <div className="flex flex-col gap-3 text-sm md:items-end" data-id="element-176" data-mp="rp07e6jszln5">
            {offer.contactEmail ? <a href={`mailto:${offer.contactEmail}`} className="text-white/85 hover:text-white" data-id="element-177" data-mp="wocrwkn7cgmk">
                {offer.contactEmail}
              </a> : <PendingNote data-id="element-178" data-mp="40z1z6hx8lby">Contact email</PendingNote>}
            {offer.socialLinks.length > 0 ? <ul className="flex gap-4" data-id="element-179" data-mp="8yigm7ij704f">
                {offer.socialLinks.map(link => <li key={link.href} data-id="element-180" data-mp="ambwrjos7xyb">
                    <a href={link.href} className="text-white/85 hover:text-white" data-id="element-181" data-mp="6lrz8f0aqsbn">
                      {link.label}
                    </a>
                  </li>)}
              </ul> : <PendingNote data-id="element-182" data-mp="3t1w861bl5qfz">Social links</PendingNote>}
            {offer.legalLinks.length > 0 ? <ul className="flex gap-4" data-id="element-183" data-mp="3o2t5gnj2vwb6">
                {offer.legalLinks.map(link => <li key={link.href} data-id="element-184" data-mp="3j1vr6m16vmey">
                    <a href={link.href} className="text-white/70 hover:text-white" data-id="element-185" data-mp="3j51b7muyny3t">
                      {link.label}
                    </a>
                  </li>)}
              </ul> : <PendingNote data-id="element-186" data-mp="1d9yr2yy7kkze">Terms &amp; privacy links</PendingNote>}
          </div>
        </div>
        <p className="mt-10 max-w-[680px] border-t border-white/10 pt-6 text-xs leading-relaxed text-white/60" data-id="element-187" data-mp="18b5b8zvg8hw2">
          Professional printable resources in English. Activities require selection and adaptation by an appropriately
          qualified professional. This kit does not replace assessment or clinical judgment and makes no claim of
          guaranteed outcomes. Illustrative cover shown. No physical book is shipped.
        </p>
      </div>
    </footer>;
}